module.exports = __webpack_public_path__ + "img/gys_12@2x.fda00e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_12@2x.png
// module id = Zq/x
// module chunks = 0